<div class="layout-wrapper" [ngClass]="containerClass">
    <app-topbar (showDialogCompanies)="showDialogCompanies()" (showDialogOrganisations)="showDialogOrganisations()"></app-topbar>
    <div class="layout-sidebar" *ngIf="selectedCompany && !selectedCompany.organisation_id">
        <app-drawer></app-drawer>
    </div>

    <div class="flex flex-column layout-sidebar custom" style="gap: 2rem; background-color: none" *ngIf="!selectedCompany || (selectedCompany && selectedCompany.organisation_id)">
        <div class="custom-menu">
            <app-drawer menu="menu-orga"></app-drawer>
        </div>
        <div class="custom-menu">
            <app-drawer menu="menu-company-orga"></app-drawer>
        </div>
    </div>

    <div class="layout-main-container">
        <div class="layout-main">
            <router-outlet></router-outlet>
        </div>
        <app-footer></app-footer>
    </div>
    <!-- <app-config></app-config> -->
    <div class="layout-mask"></div>

    <p-dialog header="Changer de base" [modal]="true" [(visible)]="modalCompaniesVisible" [style]="{ width: '25rem' }">
        <div class="p-fluid mt-4 mb-4" *ngIf="currentUser && (currentUser.is_superadmin || currentUser.companies.length > 1)">
            <p-select
                [loading]="false"
                [options]="companies"
                [(ngModel)]="selectedCompany"
                optionLabel="name"
                placeholder="Choisir une base"
                (onChange)="onCompanyChange($event)"
                dataKey="id"
                appendTo="body"
                [filter]="true"
                filterBy="name"
            />
        </div>
    </p-dialog>

    <p-dialog header="Changer d'organisation" [modal]="true" [(visible)]="modalOrganisationsVisible" [style]="{ width: '25rem' }">
        <div class="p-fluid mt-4 mb-4" *ngIf="currentUser && (currentUser.is_superadmin || currentUser.organisations.length > 1)">
            <p-select
                [loading]="false"
                [options]="organisations"
                [(ngModel)]="selectedOrganisation"
                optionLabel="name"
                placeholder="Choisir une organisation"
                (onChange)="onOrganisationChange($event)"
                dataKey="id"
                appendTo="body"
                [filter]="true"
                filterBy="name"
            />
        </div>
    </p-dialog>
</div>
